// hooks/useMissingInsurance.ts
import { useQuery } from "react-query";
import RequisitionType from "Services/Requisition/RequisitionTypeService";

export const missingInsuranceKeys = {
  all: ["missingInsurance"] as const,
  list: (params: SearchParams) =>
    [...missingInsuranceKeys.all, params] as const,
};

interface SearchParams {
  tabId: number;
  pageNumber: number;
  pageSize: number;
  sortColumn: string;
  sortDirection: string;
  filters: any[];
}

const useMissingInsurance = (params: SearchParams) => {
  return useQuery(
    missingInsuranceKeys.list(params),   // arg 1: query key
    async () => {                         // arg 2: query fn
      const cleanedFilters = params.filters?.map((filter: any) => ({
        ...filter,
        filterValue:
          typeof filter.filterValue === "string"
            ? filter.filterValue.trim()
            : filter.filterValue,
      }));

      const response = await RequisitionType.MissingInsurance({
        ...params,
        filters: cleanedFilters,
      });

      return {
        data: response.data?.data ?? [],
        total: response.data?.total ?? 0,
      };
    },
    {                                     
      keepPreviousData: true,  
      staleTime: 30_000,
    }
  );
};

export default useMissingInsurance;